var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { keyframes } from 'styled-components';
export var toCSS = function (value) {
    if (!!Number(value) || Number(value) === 0) {
        return value + "px";
    }
    return value;
};
export var convertToCSSValue = function (value) {
    return value + "px";
};
export var convertUndefinedCSSValue = function (value) {
    return value == undefined ? '' : value;
};
export var getGeometryStyle = function (geometry) {
    if (!geometry)
        return '';
    return "\n        " + (geometry.x != undefined && geometry.y != undefined
        ? "\n            position: absolute;\n            top: " + convertToCSSValue(geometry.y) + ";\n            left: " + convertToCSSValue(geometry.x) + ";\n        "
        : "\n            position: relative;\n        ") + ";\n        " + (geometry.height
        ? "height: " + convertToCSSValue(geometry.height) + ";"
        : '') + ";\n        " + (geometry.width ? "width: " + convertToCSSValue(geometry.width) + ";" : '') + ";\n        box-sizing: border-box;\n    ";
};
export var blinkingAnimation = function (color1, color2) { return keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    0% {\n        background-color: ", ";\n    }\n    50% {\n        background-color: ", ";\n    }\n    100% {\n        background-color: ", ";\n    }\n"], ["\n    0% {\n        background-color: ", ";\n    }\n    50% {\n        background-color: ", ";\n    }\n    100% {\n        background-color: ", ";\n    }\n"])), color1, color2, color1); };
export var getTextAlignment = function (alignment) {
    var style = 'text-align: ';
    var defaultStyle = style + 'left;';
    if (!alignment)
        return defaultStyle;
    switch (alignment.trim().toLowerCase()) {
        case 'alignright':
            return style + 'right;';
        case 'aligncenter':
            return style + 'center;';
        case 'alignleft':
        default:
            return defaultStyle;
    }
};
export var getColor = function (color) { return color.replace('0x', '#'); };
export var getMinimumHeight = function (minimumSize) {
    return (minimumSize === null || minimumSize === void 0 ? void 0 : minimumSize.height) ? convertToCSSValue(minimumSize.height) : '';
};
export var getMinimumWidth = function (minimumSize) {
    return (minimumSize === null || minimumSize === void 0 ? void 0 : minimumSize.width) ? convertToCSSValue(minimumSize.width) : '';
};
export var getMaximumHeight = function (maximumSize) {
    return (maximumSize === null || maximumSize === void 0 ? void 0 : maximumSize.height) ? convertToCSSValue(maximumSize.height) : '';
};
export var getMaximumWidth = function (maximumSize) {
    return (maximumSize === null || maximumSize === void 0 ? void 0 : maximumSize.width) ? convertToCSSValue(maximumSize.width) : '';
};
export var getMinHeightWidth = function (minimumSize) {
    return "\n  min-height: " + getMinimumHeight(minimumSize) + ";\n  min-width: " + getMinimumWidth(minimumSize) + ";";
};
export var getMaxHeightWidth = function (maximumSize) {
    return "\n  max-height: " + getMaximumHeight(maximumSize) + ";\n  max-width: " + getMaximumWidth(maximumSize) + ";";
};
export var getHeightWidth = function (width, height) {
    if (height && width) {
        return "\n      height: " + height + ";\n      width: " + width + ";";
    }
    return "";
};
export var getWidth = function (width) {
    if (width) {
        return "\n      width: " + width + ";";
    }
    return "";
};
export var updateStylesheet = function (styleSheet, type) {
    var startIndex = type + "{";
    if (styleSheet) {
        if (styleSheet.indexOf(type) < 0) {
            return styleSheet;
        }
        return styleSheet.substring(startIndex.length, styleSheet.length - 1) + ";";
    }
    return '';
};
export var getNotsPlayerResolution = function () {
    return "\n        width: 100%;\n        height: 100%;\n        min-width: 1920px;\n        min-height: 1080px;\n        max-width: 2560px;\n        max-height: 1600px;\n    ";
};
var templateObject_1;
//# sourceMappingURL=styles.js.map